import React, { useEffect } from 'react';
import { Prompt } from 'react-router';

import { UNSAVED_CONFIRM_MESSAGE } from '../constants/Common';
import { useTranslation } from '../custom-hooks/useTranslation';
import { checkForUnsavedChangesBeforeUnload } from '../utils/unsavedChangesUtils';

const UnsavedChangesPrompt = ({ hasUnsavedChanges }) => {
  const translateString = useTranslation();
  const confirmMessage = translateString(UNSAVED_CONFIRM_MESSAGE);

  useEffect(() => {
    checkForUnsavedChangesBeforeUnload({
      hasUnsavedChanges,
      confirmMessage,
    });

    return () => {
      checkForUnsavedChangesBeforeUnload({ hasUnsavedChanges: false });
    };
  }, [hasUnsavedChanges, confirmMessage]);

  return <Prompt when={hasUnsavedChanges} message={confirmMessage} />;
};

export default UnsavedChangesPrompt;
